import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

interface RedirectProps {
  link: string;
}

const Redirect: React.FC<RedirectProps> = ({ link }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const redirectTimeout = setTimeout(() => {
      navigate(link);
    }, 1000);

    return () => clearTimeout(redirectTimeout);
  }, [navigate, link]);

  return (
    <div>
      <p>Redirection en cours...</p>
    </div>
  );
};

export default Redirect;
